// Single master on/off switch for AI-powered marketing surfaces in the
// frontend (mirrors /app/backend/ai/feature_flags.py). Flip this back to
// `true` — together with the backend flag — to restore the full Session
// Planner / LXRA Intelligence experience with no other code changes.
export const AI_FEATURES_ENABLED = false;
